import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { tap, first } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Themes } from '../../core/themes/themes.model';
import { select } from '@angular-redux/store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lista-themes',
  templateUrl: './lista-themes.component.html',
  styleUrls: ['./lista-themes.component.scss']
})
export class ListaThemesComponent implements OnInit {
  displayedColumns: string[] = ['themes_name'];
  dataSource: MatTableDataSource<Themes>;
  current_lang = 'it';

  @select(['theme', 'list'])
  theme_list$: Observable<any>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private titleService: Title,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.current_lang = this.translate.currentLang;
      this.translate.use(this.current_lang);
    } else {
      this.translate.use('it');
      this.current_lang = this.translate.currentLang;
    }
    this.translate.get('breadcrumb.admin_themes').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('breadcrumb.admin_themes').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.theme_list$.pipe(
      first(),
      tap((list) => {
        this.dataSource = new MatTableDataSource(list);
      })
    ).subscribe(() => this.dataSource.paginator = this.paginator);
  }

  applyFilter(event: Event) {
    this.dataSource.filterPredicate = (data: Themes, filter: string) => data.name[this.current_lang].toLowerCase().includes(filter);
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource && this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
    this.translate.get('admin_themes.paginator').subscribe(translation => {
      this.paginator._intl.itemsPerPageLabel = translation.items_per_page;
      this.paginator._intl.nextPageLabel = translation.next;
      this.paginator._intl.previousPageLabel = translation.prev;
      this.paginator._intl.getRangeLabel = function(page, pageSize, length) {
        const of = translation.elem_of_tot;
        if (length === 0 || pageSize === 0) {
          return '0 ' + of + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
          Math.min(startIndex + pageSize, length) :
          startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
      };
    });
  }

}
